import { Backdrop, Box, Card, Grid, TextField, Typography } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  addInventoryItemAction,
  getAllCargoUnits,
  getInventoryItemStatusListingAction,
  getWareHouseListingAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import {
  loader,
  selectInventoryItemStatusListing,
  selectResetAddForm,
  selectSubmitAddForm,
  selectWareHouseListing,
} from "src/app-redux/warehouse/wareHouseSlice";
import { IAddInventoryItem } from "src/common/typings/warehouse";
import { showNotification } from "src/common/utils/app.util";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { number, object, string } from "yup";
import CommonAutoCompleteField from "../../../../../../components/CommonAutoCompleteField/CommonAutoCompleteField";
import { useStyles } from "./styles";
import { disableCopy, disablePaste, validationNumber } from "src/common/utils/formValidation";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonLoader from "src/components/Loader/CommonLoader";

export interface IForm extends IAddInventoryItem {}

interface Props {}
export function AddItemInputFields({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const history = useHistory();
  // Form Submissions

  const validationSchema = object({
    detainedByName: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),
    detainedByDesignation: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),

    detainedByDepartment: string().when("isDetained", {
      is: () => {
        if (formik.values.isDetained == 1) {
          return true;
        }
      },
      then: string().required("This field is required.").max(50, "Maximum 50 characters allowed"),
      otherwise: string(),
    }),
    itemCode: string().max(50, "Maximum 50 characters allowed"),
    modelNumber: string().max(50, "Maximum 50 characters allowed"),
    serialNumber: string().max(50, "Maximum 50 characters allowed"),
    supplierName: number().required("This field is required."),

    importerPhoneNumber: string()
      .max(20, "Maximum 12 characters allowed")
      .test("len", "Invalid Phone Number No.", (val = "") => {
        const val_length_without_dashes = val.replace(/-|_/g, "").length;
        return val_length_without_dashes === 13 || val_length_without_dashes === 0;
      }),
    exporterPhoneNumber: string()
      .max(20, "Maximum 12 characters allowed")
      .test("len", "Invalid Phone Number No.", (val = "") => {
        const val_length_without_dashes = val.replace(/-|_/g, "").length;
        return val_length_without_dashes === 13 || val_length_without_dashes === 0;
      }),
    isBannedItem: number().required("This field is required."),
    name: string().required("This field is required."),
    entryReason: string()
      .required("This field is required")
      .max(50, "Maximum 50 characters allowed"),
    inventoryNameId: string().required("This field is required."),
    warehouseId: string().required("This field is required"),
    cargoValue: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    weight: number()
      .required("This field is required")
      .min(1, "Minimum 1 digits are allowed")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionLength: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionWidth: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    dimensionHeight: number()
      .min(0, "Minimum should be zero")
      .max(10000000000, "Maximum 10 digits are allowed"),
    statusId: string().required("This field is required."),
    remarks: string().max(3000, "Maximum 3000 characters allowed"),
  });
  const formik = useFormik<IAddInventoryItem>({
    initialValues: {
      InventoryType: 0,
      isDetained: 0,
      detainedByName: "",
      detainedByDepartment: "",
      detainedByDesignation: "",
      supplierName: "",
      importerId: 0,
      importerPhoneNumber: "",
      exporterId: 0,
      exporterPhoneNumber: "",
      gatePassId: 0,
      isBannedItem: 0,
      inventoryNameId: "",
      name: "",
      modelNumber: "",
      serialNumber: "",
      warehouseId: "",
      entryDate: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
      registrationNumber: "",
      itemCode: "",
      entryReason: "",
      remarks: "",
      weight: "",
      inspectionStatus: "",
      statusId: "",
      dimensionLength: "",
      dimensionWidth: "",
      dimensionHeight: "",
      cargoValue: "",
      weightUnit: "",
      dimensionUnit: "",
      currency: "PKR",
      driverName: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (
        Number(values.statusId) == 2 &&
        (Number(values?.weight) > 0 ||
          Number(values.dimensionWidth) > 0 ||
          Number(values.dimensionHeight) > 0 ||
          Number(values.dimensionLength) > 0 ||
          Number(values.cargoValue) > 0)
      ) {
        return dispatch(
          addNotificationAction({
            message: "Item with 'Out-of-warehouse' status cannot be added",
            options: { variant: "error" },
          })
        );
      }
      if (gatePassId === 0) {
        dispatch(
          addNotificationAction({
            message: "Select vehicle number first!",
            options: { variant: "error" },
          })
        );
      } else {
        const res: any = await dispatch(
          addInventoryItemAction({
            ...values,
            weight: Number(values.weight),
            dimensionWidth: Number(values.dimensionWidth),
            dimensionHeight: Number(values.dimensionHeight),
            dimensionLength: Number(values.dimensionLength),
            cargoValue: Number(values.cargoValue),
          })
        );
        if (res.payload) {
          actions.setSubmitting(false);
          history.push("list-inventory");
          return;
        }
      }
    },
  });
  // End Form submission

  const { height } = UseWindowDimensions(); // get browser dimension
  const minAccHeight = 50; // Right Content
  let accordionMaxHeight = 0;
  accordionMaxHeight = height - minAccHeight;

  const [loader2, setLoader2] = useState(false);
  const [gatePassId, setGatePassId] = useState<any>(0);
  // Redux
  const loading = useAppSelector(loader);
  const wareHouseListing = useAppSelector(selectWareHouseListing);
  const inventoryItemStatusListing = useAppSelector(selectInventoryItemStatusListing);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any>([]);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [cargoTypeData, setCargoTypeData] = React.useState<any>([]);
  const [allUnits, setAllUnits] = useState<any>([]);
  const inspectionStatusLinst = [
    { id: 1, name: "Passed" },
    { id: 0, name: "Failed" },
    { id: 2, name: "Detained" },
    { id: 3, name: "Other" },
  ];
  const InventoryTypeLinst = [
    { id: 0, name: "Cargo" },
    { id: 1, name: "Seized" },
    { id: 2, name: "Detained" },
  ];

  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    // setLoader2(true);
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    // setLoader2(false);
    return;
  };
  const getVehicleDetailsByRegNo = async (id: number, title: string) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`get-vehicle-driver-detail-by-vehicle-reg-numb/${title}`);
      if (results.isSuccess == true) {
        formik.setFieldValue("registrationNumber", title);
        const resultObj = results.value.vehicleDriverDetail;
        setGatePassId(resultObj.gatePassId);
        formik.setFieldValue("gatePassId", resultObj.gatePassId);
        formik.setFieldValue("driverName", resultObj.driverName);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };
  useEffect(() => {
    if (wareHouseListing.length === 0) dispatch(getWareHouseListingAction());
    if (inventoryItemStatusListing.length === 0) dispatch(getInventoryItemStatusListingAction());
  }, []);

  // Submit Buttons
  const counterSubmitAddForm = useAppSelector(selectSubmitAddForm);
  const counterResetAddForm = useAppSelector(selectResetAddForm);
  useEffect(() => {
    if (formik.isValid === false) {
      showNotification("Please fill complete form.", "error", dispatch);
    }
    if (counterSubmitAddForm) {
      formik.submitForm();
    }
  }, [counterSubmitAddForm]);
  useEffect(() => {
    if (counterResetAddForm) formik.resetForm();
  }, [counterResetAddForm]);

  // cargo type
  const getVehicleConfiguration = async () => {
    try {
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        setCargoTypeData(results.value);
        return;
      }
    } catch (error: any) {}
  };
  useEffect(() => {
    getVehicleConfiguration();
    getListing();
    getAllUnits();
  }, []);

  const scrollContainerRef: any = useRef(null);
  const datePickerRef: any = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      // Hide the calendar when the container is scrolled
      datePickerRef?.current?.flatpickr?.close();
    };
    scrollContainerRef?.current?.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [supplierTypeList, setSupplierTypeList] = useState([]);

  const getListing = async () => {
    let results: any = [];
    try {
      results = await fetchWrapper.get(`get_all-supplier-details?getActiveSuppliersOnly=${true}`);
      if (results.isSuccess == true) {
        setSupplierTypeList(results.value);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  const getAllUnits = async () => {
    const res = await dispatch(getAllCargoUnits());
    setAllUnits(res.payload || []);
  };

  const supplierNameHandler = async (id: any) => {
    formik.setFieldValue("supplierName", id);
    const supplier: any = await supplierTypeList.find((st: any) => st.id === id);
    if (supplier.supplierType == "Importer") {
      formik.setFieldValue("importerId", id);
      formik.setFieldValue("exporterId", 0);
    } else if (supplier.supplierType == "Exporter") {
      formik.setFieldValue("exporterId", id);
      formik.setFieldValue("importerId", 0);
    } else {
      formik.setFieldValue("importerId", 0);
      formik.setFieldValue("exporterId", 0);
    }
  };

  return (
    <>
      <form>
        <Backdrop className={classes.backdrop} open={loading || loader2}>
          <CommonLoader />
        </Backdrop>
        <Grid container direction="row" alignItems="flex-start">
          <>
            <Grid
              item
              md={12}
              component={Card}
              className={classes.tabCardContent}
              ref={scrollContainerRef}
              style={{ height: accordionMaxHeight }}
            >
              <Grid className={classes.UserMainPanel}>
                <Grid container direction="row" alignItems="center" spacing={2}>
                  {/* Vehicle Driver Details */}
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Driver and Vehicle Details</Typography>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Vehicle Number"
                          placeholder="Select Vehicle Number"
                          name="registrationNumber"
                          optionsType={vehicleRegNumberArr}
                          getOptionLabel={(option) => option.registrationNumber}
                          required
                          value={
                            vehicleRegNumberArr.find(
                              (st: any) =>
                                st.registrationNumber === formik.values.registrationNumber
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.registrationNumber !== "" && option.vehicleId !== 0
                              ? getVehicleDetailsByRegNo(
                                  option.vehicleId,
                                  option.registrationNumber
                                )
                              : formik.setFieldValue("registrationNumber", "");
                          }}
                          onKeyUp={(e: any) => {
                            setVehicleNumberLength(e.target.value.length);

                            if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                              getVehicleByRegistrationNo(e.target.value);
                              return;
                            }
                          }}
                          onKeyDownCapture={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                          }}
                          onPaste={(e: any) => {
                            if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                              e.preventDefault();
                              return;
                            }

                            if (e.clipboardData.getData("text").length >= 2)
                              getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                          }}
                          error={
                            formik.touched.registrationNumber &&
                            Boolean(formik.errors.registrationNumber)
                          }
                          helperText={
                            formik.touched.registrationNumber && formik.errors.registrationNumber
                          }
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Importer/ Exporter Name"
                          placeholder="Select Importer/Exporter Name"
                          name="supplierName"
                          optionsType={supplierTypeList}
                          getOptionLabel={(option: any) =>
                            option.supplierName && option.supplierType
                              ? `${option.supplierType} - ${option.supplierName}`
                              : option.supplierName
                              ? option.supplierName
                              : ""
                          }
                          renderOption={(option) => (
                            <span>
                              {option.supplierName && option.supplierType
                                ? `${option.supplierType} - ${option.supplierName}`
                                : option.supplierName
                                ? option.supplierName
                                : ""}
                            </span>
                          )}
                          required
                          value={
                            supplierTypeList.find(
                              (st: any) => st.id === formik.values.supplierName
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option !== "" ? supplierNameHandler(option.id) : "";
                          }}
                          error={formik.touched.supplierName && Boolean(formik.errors.supplierName)}
                          helperText={formik.touched.supplierName && formik.errors.supplierName}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className="customTextField"
                          required
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Driver Name"
                          name="driverName"
                          placeholder="Driver Name"
                          disabled={true}
                          value={formik.values.driverName}
                        />
                      </Box>
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Importer Name"
                          placeholder="Select Importer Name"
                          name="importerId"
                          optionsType={supplierTypeList.filter(
                            (option: any) => option.supplierType == "Importer"
                          )}
                          getOptionLabel={(option: any) => option.supplierName || ""}
                          renderOption={(option) => <span>{option.supplierName}</span>}
                          required
                          value={
                            supplierTypeList.find(
                              (st: any) => st.id === formik.values.importerId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option !== ""
                              ? formik.setFieldValue("importerId", option.id)
                              : "";
                          }}
                          error={formik.touched.importerId && Boolean(formik.errors.importerId)}
                          helperText={formik.touched.importerId && formik.errors.importerId}
                        />
                      </Box>
                    </Grid> */}
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <InputMask
                          mask="+99-999-999-9999"
                          value={formik.values.importerPhoneNumber}
                          disabled={false}
                          onChange={(e) =>
                            formik.setFieldValue("importerPhoneNumber", e.target.value)
                          }
                        >
                          {() => (
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Importer Phone Number"
                              name="importerPhoneNumber"
                              id="importerPhoneNumber"
                              placeholder="+92-123-456-7890"
                              type="text"
                              error={
                                formik.touched.importerPhoneNumber &&
                                Boolean(formik.errors.importerPhoneNumber)
                              }
                              helperText={
                                formik.touched.importerPhoneNumber &&
                                formik.errors.importerPhoneNumber
                              }
                            />
                          )}
                        </InputMask>
                      </Box>
                    </Grid> */}
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <CommonAutoCompleteField
                          required
                          cssClassName="customTextField"
                          label="Exporter Name"
                          placeholder="Select Exporter Name"
                          name="exporterId"
                          optionsType={supplierTypeList.filter(
                            (option: any) => option.supplierType == "Exporter"
                          )}
                          getOptionLabel={(option: any) => option.supplierName || ""}
                          renderOption={(option) => <span>{option.supplierName}</span>}
                          // required
                          value={
                            supplierTypeList.find(
                              (st: any) => st.id === formik.values.exporterId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option !== ""
                              ? formik.setFieldValue("exporterId", option.id)
                              : "";
                          }}
                          error={formik.touched.exporterId && Boolean(formik.errors.exporterId)}
                          helperText={formik.touched.exporterId && formik.errors.exporterId}
                        />
                      </Box>
                    </Grid> */}
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <InputMask
                          mask="+99-999-999-9999"
                          value={formik.values.exporterPhoneNumber}
                          disabled={false}
                          onChange={(e) =>
                            formik.setFieldValue("exporterPhoneNumber", e.target.value)
                          }
                        >
                          {() => (
                            <TextField
                              size="small"
                              fullWidth
                              className="customTextField"
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Exporter Phone Number"
                              name="exporterPhoneNumber"
                              id="exporterPhoneNumber"
                              placeholder="+92-123-456-7890"
                              type="text"
                              error={
                                formik.touched.exporterPhoneNumber &&
                                Boolean(formik.errors.exporterPhoneNumber)
                              }
                              helperText={
                                formik.touched.exporterPhoneNumber &&
                                formik.errors.exporterPhoneNumber
                              }
                            />
                          )}
                        </InputMask>
                      </Box>
                    </Grid> */}
                  </>
                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Item Details </Typography>
                  </Grid>
                  <>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          required
                          cssClassName="customTextField"
                          error={
                            formik.touched.InventoryType && Boolean(formik.errors.InventoryType)
                          }
                          helperText={formik.touched.InventoryType && formik.errors.InventoryType}
                          label="Inventory Type"
                          placeholder="Select Inventory Type"
                          name="InventoryType"
                          optionsType={InventoryTypeLinst}
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            InventoryTypeLinst.find(
                              (st: any) => st.id === formik.values.InventoryType
                            ) || null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("InventoryType", option.id);
                            formik.setFieldValue("inventoryNameId", "");
                            formik.setFieldValue("name", "");
                            formik.setFieldValue("weightUnit", "");
                            formik.setFieldValue("dimensionUnit", "");
                            if (option.id == 2) {
                              formik.setFieldValue("isDetained", 1);
                              formik.setFieldValue("isBannedItem", 0);
                            } else if (option.id == 1) {
                              formik.setFieldValue("isDetained", 0);
                              formik.setFieldValue("isBannedItem", 1);
                            } else {
                              formik.setFieldValue("isDetained", 0);
                              formik.setFieldValue("isBannedItem", 0);
                            }
                          }}
                        />
                      </Box>
                    </Grid>
                    {/* <Grid item xs={12} md={7} lg={5}>
                        <Box>
                          <FormControl component="fieldset">
                            <FormLabel component="legend" className={classes.legend}>
                              Inventory Type
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-label="gender"
                              name="gender1"
                              value={formik.values.isBannedItem}
                              onChange={(event: any) => {
                                formik.setFieldValue("isBannedItem", Number(event.target.value));
                                formik.setFieldValue("inventoryNameId", 0);
                                formik.setFieldValue("name", "");
                                formik.setFieldValue("weightUnit", "");
                                formik.setFieldValue("dimensionUnit", "");
                              }}
                            >
                              <FormControlLabel
                                value={0}
                                checked={formik.values.isBannedItem == 0}
                                control={<Radio />}
                                label="Cargo"
                              />
                              <FormControlLabel
                                value={1}
                                checked={formik.values.isBannedItem == 1}
                                control={<Radio />}
                                label="Seized"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </Grid> */}
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Item Name"
                          name="inventoryNameId"
                          optionsType={
                            formik.values.InventoryType == 0
                              ? cargoTypeData.cargoTypeData
                              : formik.values.InventoryType == 1
                              ? cargoTypeData.bannedItemData
                              : [...cargoTypeData.cargoTypeData, ...cargoTypeData.bannedItemData]
                          }
                          placeholder="Select Item Name"
                          required
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            formik.values.isBannedItem == 0
                              ? cargoTypeData?.cargoTypeData?.find(
                                  (st: any) => st.id === formik.values.inventoryNameId
                                ) || null
                              : cargoTypeData?.bannedItemData?.find(
                                  (st: any) => st.id === formik.values.inventoryNameId
                                ) || null
                          }
                          onChange={(option: any) => {
                            if (option && option.id !== 0) {
                              formik.setFieldValue("inventoryNameId", option.id);
                              formik.setFieldValue("name", option.name);
                              formik.setFieldValue("weightUnit", option.unitId);
                              formik.setFieldValue("dimensionUnit", option.unitId);
                              if (option.isBannedItem) {
                                formik.setFieldValue("isBannedItem", 1);
                              } else {
                                formik.setFieldValue("isBannedItem", 0);
                              }

                              // handleValueChange({ target: { value: option.name } });
                            }
                          }}
                          error={
                            formik.touched.inventoryNameId && Boolean(formik.errors.inventoryNameId)
                          }
                          helperText={
                            formik.touched.inventoryNameId && formik.errors.inventoryNameId
                          }
                        />
                      </Box>
                    </Grid>
                    {formik.values.isDetained == 1 && (
                      <>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Name"
                              name="detainedByName"
                              placeholder="Enter Name"
                              disabled={false}
                              value={formik.values.detainedByName}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByName &&
                                Boolean(formik.errors.detainedByName)
                              }
                              helperText={
                                formik.touched.detainedByName && formik.errors.detainedByName
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Department"
                              name="detainedByDepartment"
                              placeholder="Enter Department"
                              disabled={false}
                              value={formik.values.detainedByDepartment}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByDepartment &&
                                Boolean(formik.errors.detainedByDepartment)
                              }
                              helperText={
                                formik.touched.detainedByDepartment &&
                                formik.errors.detainedByDepartment
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className={"customTextField"}
                              required={formik.values.isDetained == 1}
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Designation"
                              name="detainedByDesignation"
                              placeholder="Enter Designation"
                              disabled={false}
                              value={formik.values.detainedByDesignation}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.detainedByDesignation &&
                                Boolean(formik.errors.detainedByDesignation)
                              }
                              helperText={
                                formik.touched.detainedByDesignation &&
                                formik.errors.detainedByDesignation
                              }
                            />
                          </Box>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} md={4} lg={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Item Code"
                          name="itemCode"
                          placeholder="Enter Item Code"
                          disabled={false}
                          value={formik.values.itemCode}
                          onChange={formik.handleChange}
                          error={formik.touched.itemCode && Boolean(formik.errors.itemCode)}
                          helperText={formik.touched.itemCode && formik.errors.itemCode}
                        />
                      </Box>
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Model Number"
                          name="modelNumber"
                          placeholder="Model Number"
                          disabled={false}
                          value={formik.values.modelNumber}
                          onChange={formik.handleChange}
                          error={formik.touched.modelNumber && Boolean(formik.errors.modelNumber)}
                          helperText={formik.touched.modelNumber && formik.errors.modelNumber}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Serial Number"
                          name="serialNumber"
                          placeholder="Serial Number"
                          disabled={false}
                          value={formik.values.serialNumber}
                          onChange={formik.handleChange}
                          error={formik.touched.serialNumber && Boolean(formik.errors.serialNumber)}
                          helperText={formik.touched.serialNumber && formik.errors.serialNumber}
                        />
                      </Box>
                    </Grid> */}
                    <Grid item xs={12} md={4}>
                      <Box>
                        <TextField
                          className={"customTextField"}
                          required
                          size="small"
                          fullWidth
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Reason for Entry"
                          name="entryReason"
                          placeholder="Enter Reason for Entry"
                          disabled={false}
                          value={formik.values.entryReason}
                          onChange={formik.handleChange}
                          error={formik.touched.entryReason && Boolean(formik.errors.entryReason)}
                          helperText={formik.touched.entryReason && formik.errors.entryReason}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={formik.touched.warehouseId && Boolean(formik.errors.warehouseId)}
                          helperText={formik.touched.warehouseId && formik.errors.warehouseId}
                          label="Warehouse"
                          placeholder="Select Warehouse"
                          name="warehouseId"
                          optionsType={wareHouseListing}
                          required
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            wareHouseListing.find(
                              (st: any) => st.id === formik.values.warehouseId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.id !== 0
                              ? formik.setFieldValue("warehouseId", option.id)
                              : "";
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          label="Item Status"
                          placeholder="Select Item Status"
                          name="statusId"
                          optionsType={inventoryItemStatusListing}
                          required
                          getOptionLabel={(option: any) => option.status || ""}
                          value={
                            inventoryItemStatusListing.find(
                              (st: any) => st.id === formik.values.statusId
                            ) || null
                          }
                          onChange={(option: any) => {
                            option && option.id !== 0
                              ? formik.setFieldValue("statusId", option.id)
                              : "";
                          }}
                          error={formik.touched.statusId && Boolean(formik.errors.statusId)}
                          helperText={formik.touched.statusId && formik.errors.statusId}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          error={
                            formik.touched.inspectionStatus &&
                            Boolean(formik.errors.inspectionStatus)
                          }
                          helperText={
                            formik.touched.inspectionStatus && formik.errors.inspectionStatus
                          }
                          label="Inspection Status"
                          placeholder="Select Inspection Status"
                          name="InspectionStatus"
                          optionsType={inspectionStatusLinst}
                          getOptionLabel={(option: any) => option.name || ""}
                          value={
                            inspectionStatusLinst.find(
                              (st: any) => st.id === formik.values.inspectionStatus
                            ) || null
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue("inspectionStatus", option.id);
                          }}
                        />
                      </Box>
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                      <Box>
                        <FormControl component="fieldset">
                          <FormLabel component="legend" className={classes.legend}>
                            Inspection Status
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-label="gender"
                            name="gender1"
                            value={formik.values.inspectionStatus}
                            onChange={(event: any) => {
                              formik.setFieldValue("inspectionStatus", event.target.value);
                            }}
                          >
                            <FormControlLabel value="Passed" control={<Radio />} label="Passed" />
                            <FormControlLabel value="Failed" control={<Radio />} label="Failed" />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Grid> */}
                  </>

                  <Grid item md={12} className={classes.sectionHeading}>
                    <Typography>Item Specifications</Typography>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        required
                        className={"customTextField"}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Quantity"
                        name="weight"
                        placeholder="Enter Quantity"
                        value={formik.values.weight}
                        onChange={formik.handleChange}
                        error={formik.touched.weight && Boolean(formik.errors.weight)}
                        helperText={formik.touched.weight && formik.errors.weight}
                        onBlur={() => {
                          const num = parseFloat(formik.values.weight || "0");
                          const cleanNum = num.toFixed(2);
                          formik.setFieldValue("weight", cleanNum);
                        }}
                        onKeyDown={(evt) => validationNumber(evt)}
                        onCopy={disableCopy}
                        onPaste={disablePaste}
                        onCut={disableCopy}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        error={formik.touched.weightUnit && Boolean(formik.errors.weightUnit)}
                        helperText={formik.touched.weightUnit && formik.errors.weightUnit}
                        label="UOM"
                        placeholder="UOM"
                        name="weightUnit"
                        optionsType={allUnits}
                        getOptionLabel={(option) =>
                          option.unit == "Cubic meter" ? "m³" : option.unit
                        }
                        value={
                          allUnits.find(({ id }: any) => id === formik.values.weightUnit) || null
                        }
                        disabled={true}
                        // onChange={(option: any) => {
                        //   option ? formik.setFieldValue("weightUnit", option) : "";
                        // }}
                      />
                    </Box>
                  </Grid>
                  {/* <Grid item md={6}></Grid> */}
                  {/* <Grid item xs={12} md={3}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Length"
                        name="dimensionLength"
                        placeholder="Length"
                        disabled={false}
                        value={formik.values.dimensionLength}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.dimensionLength && Boolean(formik.errors.dimensionLength)
                        }
                        helperText={formik.touched.dimensionLength && formik.errors.dimensionLength}
                        onBlur={() => {
                          const num = parseFloat(formik.values.dimensionLength || "0");
                          const cleanNum = num.toFixed(2);
                          formik.setFieldValue("dimensionLength", cleanNum);
                        }}
                        onKeyDown={(evt) => validationNumber(evt)}
                        onCopy={disableCopy}
                        onPaste={disablePaste}
                        onCut={disableCopy}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Width"
                        name="dimensionWidth"
                        placeholder="Width"
                        disabled={false}
                        value={formik.values.dimensionWidth}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.dimensionWidth && Boolean(formik.errors.dimensionWidth)
                        }
                        helperText={formik.touched.dimensionWidth && formik.errors.dimensionWidth}
                        onBlur={() => {
                          const num = parseFloat(formik.values.dimensionWidth || "0");
                          const cleanNum = num.toFixed(2);
                          formik.setFieldValue("dimensionWidth", cleanNum);
                        }}
                        onKeyDown={(evt) => validationNumber(evt)}
                        onCopy={disableCopy}
                        onPaste={disablePaste}
                        onCut={disableCopy}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Height"
                        name="dimensionHeight"
                        placeholder="Height"
                        disabled={false}
                        value={formik.values.dimensionHeight}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.dimensionHeight && Boolean(formik.errors.dimensionHeight)
                        }
                        helperText={formik.touched.dimensionHeight && formik.errors.dimensionHeight}
                        onBlur={() => {
                          const num = parseFloat(formik.values.dimensionHeight || "0");
                          const cleanNum = num.toFixed(2);
                          formik.setFieldValue("dimensionHeight", cleanNum);
                        }}
                        onKeyDown={(evt) => validationNumber(evt)}
                        onCopy={disableCopy}
                        onPaste={disablePaste}
                        onCut={disableCopy}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        error={formik.touched.dimensionUnit && Boolean(formik.errors.dimensionUnit)}
                        helperText={formik.touched.dimensionUnit && formik.errors.dimensionUnit}
                        label="Dimension Unit"
                        placeholder="Dimension Unit"
                        name="dimensionUnit"
                        optionsType={allUnits}
                        getOptionLabel={(option) => option.unit}
                        value={
                          allUnits.find(({ id }: any) => id === formik.values.dimensionUnit) || null
                        }
                        disabled={true}
                        // onChange={(option: any) => {
                        //   option ? formik.setFieldValue("dimensionUnit", option) : "";
                        // }}
                      />
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={12} md={3}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        size="small"
                        fullWidth
                        variant="outlined"
                        type="number"
                        InputProps={{ inputProps: { min: 0 } }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Value"
                        name="cargoValue"
                        placeholder="Value"
                        disabled={false}
                        value={formik.values.cargoValue}
                        onChange={formik.handleChange}
                        error={formik.touched.cargoValue && Boolean(formik.errors.cargoValue)}
                        helperText={formik.touched.cargoValue && formik.errors.cargoValue}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        error={formik.touched.currency && Boolean(formik.errors.currency)}
                        helperText={formik.touched.currency && formik.errors.currency}
                        label="Currency"
                        placeholder="Currency"
                        name="currency"
                        optionsType={currencyUnitList}
                        getOptionLabel={(option) => option}
                        value={
                          currencyUnitList.find((st: any) => st === formik.values.currency) || null
                        }
                        onChange={(option: any) => {
                          option ? formik.setFieldValue("currency", option) : "";
                        }}
                      />
                    </Box>
                  </Grid> */}
                  <Grid item xs={12} md={4} lg={4}>
                    <CommonTextFieldDate
                      outerCss={true}
                      cssClassName={`${classes.dateTime} ${"customTextField"}`}
                      label={"Entry Date and Time"}
                      name={"dateTime"}
                      datePickerRef={datePickerRef}
                      value={formik.values.entryDate}
                      required={true}
                      onChange={(e: any) => {
                        formik.setFieldValue("entryDate", e);
                      }}
                      maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                      error={formik.touched.entryDate && Boolean(formik.errors.entryDate)}
                      helperText={formik.touched.entryDate && formik.errors.entryDate}
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Box>
                      <TextField
                        className={"customTextField"}
                        multiline
                        rows={2}
                        rowsMax={8}
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Remarks"
                        name="remarks"
                        placeholder="Enter Remarks"
                        disabled={false}
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        </Grid>
      </form>
    </>
  );
}
